import React from 'react';
import { ContainerFooter as Container, TitleFooter } from './styled';
import CourseModality from './CourseModality';
import { CourseScheduleFooterProps } from './types';
import { courseTypeLabel } from './constants';

const CourseScheduleFooter = ({ isMobile }: CourseScheduleFooterProps) => (
  <Container isMobile={isMobile} data-testid="course-schedule-footer">
    <TitleFooter>{courseTypeLabel}</TitleFooter>
    <CourseModality />
  </Container>
);

export default CourseScheduleFooter;
